import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { ValuesMarquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { DesignServices } from "@/components/site/DesignServices";
import { ServicesStrip } from "@/components/site/ServicesStrip";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Leadership } from "@/components/site/Leadership";
import { Projects } from "@/components/site/Projects";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-paper text-navy" data-testid="app-root">
      <div className="grain-overlay" />
      <Header />
      <main>
        <Hero />
        <ValuesMarquee />
        <About />
        <DesignServices />
        <ServicesStrip />
        <Services />
        <Process />
        <Leadership />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminEnquiries />} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
